/**
 * MSC coverage label: MSC's scrape reaches only its lowest-priced ~1,000
 * sailings (price-sorted window of a ~6.9k catalogue), so a Browse that shows
 * MSC must say so. Plain copy, no total, never shown for other lines alone.
 * Remove (or set MSC_COVERAGE_LABEL_ENABLED = false) when MSC paging ships.
 */
export const MSC_COVERAGE_LABEL_ENABLED = true;
export const MSC_COVERAGE_COPY = "Showing MSC's lowest-priced sailings, not every sailing.";
export const MSC_COVERAGE_COPY_MULTI = 'MSC results show only its lowest-priced sailings.';

function lineList(cruiseLine) {
  const raw = Array.isArray(cruiseLine) ? cruiseLine : String(cruiseLine || '').split(',');
  return raw.map((part) => String(part).trim()).filter(Boolean);
}

function isMscLine(name) {
  const n = String(name).trim().toLowerCase();
  return n === 'msc' || n === 'msc cruises' || n.startsWith('msc ');
}

/**
 * Copy for the strip, or '' when it must not render.
 * - empty filter (all lines): no strip
 * - MSC alone: MSC_COVERAGE_COPY
 * - MSC plus other lines: MSC_COVERAGE_COPY_MULTI, once
 * - other lines alone: no strip
 */
export function mscCoverageNote(cruiseLine) {
  if (!MSC_COVERAGE_LABEL_ENABLED) return '';
  const lines = lineList(cruiseLine);
  if (!lines.some(isMscLine)) return '';
  return lines.every(isMscLine) ? MSC_COVERAGE_COPY : MSC_COVERAGE_COPY_MULTI;
}
